import { render } from "./ServiceRequestModal.vue?vue&type=template&id=6b05d179&scoped=true"
import script from "./ServiceRequestModal.vue?vue&type=script&lang=js"
export * from "./ServiceRequestModal.vue?vue&type=script&lang=js"

import "./ServiceRequestModal.vue?vue&type=style&index=0&id=6b05d179&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b05d179"]])

export default __exports__